import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { AppConfigService } from "../../app-config/app-config.service";
import { catchError, Observable, throwError } from "rxjs";
import { Injectable } from "@angular/core";

@Injectable({
  	providedIn: 'root'
})

export class HttpDeleteParticipantService {

    public readonly URL: string;

    constructor(
        private http: HttpClient,
        private configSvc: AppConfigService
    ) {
        this.URL = this.configSvc.settings.nodeUrl + 'participants/';
    }

    public deleteParticipant$(participantID: string): Observable<void> {

        const headers = new HttpHeaders({
            'x-api-key': this.configSvc.settings.participantsAPIKey
        });

        return this.http.delete<void>(`${this.URL}${participantID}`, { headers })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    if (error.status === 204) {
                        return throwError(() => new Error('Eliminado correctamente'));
                    }
                    return throwError(() => new Error(error.error?.message || 'Error al eliminar el participante'));
                })
            );
    }

}